import { render, staticRenderFns } from "./TabRutas.vue?vue&type=template&id=7292972e&scoped=true&"
import script from "./TabRutas.vue?vue&type=script&lang=ts&"
export * from "./TabRutas.vue?vue&type=script&lang=ts&"
import style0 from "./TabRutas.vue?vue&type=style&index=0&id=7292972e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7292972e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VIcon,VRow,VTab,VTabs})
